import $ from "jquery";
import { Analytics } from '@plaudit/analytics';
const myAnalytics: Analytics = Analytics.getInstance();

export default function Slider() {
	let $slider = $('.slider');
	if ($slider.length === 0) {
		return;
	}

	const slider_slide_duration: string = '6000ms';
	const slider_loading_duration: string = '4000ms';
	// variable used in css animation
	const slider_animation_duration: string = '1000ms';

	let $controls: JQuery = $slider.find('.slider__control');
	let $slides: JQuery = $slider.find('.slider__slide');
	let $currentSlide: JQuery = $slides.filter(':last-child');
	let $currentSlideIndex: number = $slides.length - 1;
	let $previousSlide: JQuery = null;
	var sliderTimer: number = null;
	var loadingTimer: number = null;
	var resetTimer: number = null;

	/* This garauntees these values are numbers */
	let sliderDuration: number = parseFloat(slider_slide_duration);
	let loadingDuration: number = parseFloat(slider_loading_duration);
	let animationDuration: number = parseFloat(slider_animation_duration);

	let loadingTimerAllowed: boolean = false;
	let loadingTimerPaused: boolean = false;

	function startSliderTimer() {
		$currentSlide.addClass('target');
		loadingTimerAllowed = false;
		sliderTimer = window.setTimeout(setupLoadingTimer, sliderDuration - loadingDuration);
	}
	function cancelLoadingTimer() {
		$currentSlide.removeClass('loading');
		window.clearTimeout(loadingTimer);
	}
	function pauseLoadingTimer() {
		loadingTimerPaused = true;
		cancelLoadingTimer();
	}
	function resumeLoadingTimer() {
		loadingTimerPaused = false;
		startLoadingTimer();
	}
	function setupLoadingTimer() {
		loadingTimerAllowed = true;
		startLoadingTimer();
	}
	function startLoadingTimer() {
		if (!loadingTimerAllowed || loadingTimerPaused) {
			return;
		}
		loadingTimer = window.setTimeout(changeSlide, loadingDuration);
		$currentSlide.addClass('loading');
	}
	function resetpreviousSlide() {
		if ($previousSlide === null) {
			return;
		}
		$slides.not($currentSlide).removeClass('target outgoing loading firstLoad');
	}
	function changeSlide() {
		// Cancels any previously running timers
		window.clearTimeout(sliderTimer);
		window.clearTimeout(loadingTimer);
		$slider.find('.slider__control--next').trigger('click', [{ isAutoAdvance: true }]);
	}
	function controlsHandler(event: any, param: any) {
		event.preventDefault();
		
		$previousSlide = $currentSlide;
		$currentSlide.addClass('outgoing');

		// get new slide index
		if (this.classList.contains('slider__control--next')) {
			$currentSlideIndex = ($currentSlideIndex + 1) == $slides.length ? 0 : ($currentSlideIndex + 1);
		} else {
			$currentSlideIndex = ($currentSlideIndex - 1) < 0 ? ($slides.length - 1) : ($currentSlideIndex - 1);
		}
		// set currentSlide from updated index
		$currentSlide = $($slides[$currentSlideIndex]);

		window.clearTimeout(sliderTimer);
		window.clearTimeout(loadingTimer);
		window.clearTimeout(resetTimer);
		resetTimer = window.setTimeout(resetpreviousSlide, animationDuration);

		cancelLoadingTimer();
		startSliderTimer();

		if (!param || (!param.isAutoAdvance)) {
			this.classList.contains('slider__control--next')
			? myAnalytics.trackEvent('Homepage Carousel', 'Click', 'Next')
			: myAnalytics.trackEvent('Homepage Carousel', 'Click', 'Previous');
		}
	}

	(function init() {
		$currentSlide.addClass('firstLoad');
		$controls.on('click', controlsHandler);
		$slides.on('mouseenter focus', pauseLoadingTimer);
		$slides.on('mouseleave blur', resumeLoadingTimer);
		startSliderTimer();
	})();
}
